import { render, staticRenderFns } from "./ctx-menu.vue?vue&type=template&id=243d5d29&scoped=true"
import script from "./ctx-menu.vue?vue&type=script&lang=js"
export * from "./ctx-menu.vue?vue&type=script&lang=js"
import style0 from "./ctx-menu.vue?vue&type=style&index=0&id=243d5d29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243d5d29",
  null
  
)

export default component.exports